<h1 style="color: red;">請關閉開發人員工具！</h1>
<h1 style="color: red;">Please close developer tools.</h1>